import React from "react";
import styled from "styled-components/macro";

import { UnstyledButton } from "./index.style";

/**
 * Barre flottante "N collaborateurs sélectionnés"
 * @param {{ count: number, onClear: function, onExport: function }} props
 */
const SelectionBar = ({ count, onClear, onExport }) => {
    if (!count) return null;

    const plural = count > 1 ? "s" : "";
    return (
        <Bar>
            <span>{`${count} collaborateur${plural} sélectionné${plural}`}</span>
            <ClearButton onClick={onClear}>Désélectionner</ClearButton>
            <ExportButton onClick={onExport}>Exporter pour Excel</ExportButton>
        </Bar>
    );
};

export default SelectionBar;

const Bar = styled.div`
    position: fixed;
    left: 50%;
    bottom: 24px;
    transform: translateX(-50%);
    width: max-content;
    max-width: calc(100% - 32px);
    flex-wrap: wrap;
    background: #212121;
    color: #fff;
    border-radius: 6px;
    padding: 10px 12px 10px 18px;
    display: flex;
    align-items: center;
    gap: 10px 16px;
    font-size: 14px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    z-index: 10;
`;

const ClearButton = styled(UnstyledButton)`
    color: #c5c8f0;
    font-size: 13px;
`;

const ExportButton = styled(UnstyledButton)`
    background: #5b5fc7;
    color: #fff;
    border-radius: 4px;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 600;
`;
